import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";
import {
  getMessaging,
  onMessage,
  isSupported,
  Messaging,
} from "firebase/messaging";

const config = {
  apiKey: "AIzaSyCfYXcetKnQRvgBNG3PqvZohtyV0CUuM8Q",
  authDomain: "mimocupido.firebaseapp.com",
  projectId: "mimocupido",
  storageBucket: "mimocupido.firebasestorage.app",
  messagingSenderId: "493257933652",
  appId: "1:493257933652:web:0b0133d113633eaac5bec1",
  measurementId: "G-FL4YY1519B",
};

const app = initializeApp(config);

if (typeof window !== "undefined") {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(
      process.env.REACT_APP_RECAPTCHA_KEY || "",
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

// Analytics apenas no browser
export const analytics =
  typeof window !== "undefined" ? getAnalytics(app) : null;

// Instância lazy do messaging
let messagingInstance: Messaging | null = null;

// Função segura para obter messaging
export const getFirebaseMessaging = async () => {
  if (typeof window === "undefined") return null;

  const supported = await isSupported();

  if (!supported) {
    console.warn("Firebase Messaging não suportado neste navegador");
    return null;
  }

  if (!messagingInstance) {
    messagingInstance = getMessaging(app);

    // Listener foreground
    onMessage(messagingInstance, (payload) => {
      console.log("Mensagem recebida em foreground:", payload);
    });
  }

  return messagingInstance;
};

export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const auth = getAuth(app);
export const storage = getStorage(app);
export const rdb = getDatabase(app);
